/**
 * SR View - Product Page Renderer v2.1
 * 
 * 架构：
 * - 使用 SRController.on() 注册回调（显式通知，不广播）
 * - 根据 stateCode 路由到对应渲染模块
 * - 渲染模块操作 DOM，数据从 Controller 来
 * - Liquid 只输出 data 属性，不写任何 JS 逻辑
 */

(function() {
  'use strict';

  // 检查 Controller 是否加载
  if (typeof SRController === 'undefined') {
    console.error('[SR-View] SRController not found');
    return;
  }

  // ==================== Variant 数据 ====================
  
  var _variantData = null;
  var _currencyCodeEnabled = false;
  
  // 从 Liquid 读取 variant 数据
  function loadVariantData() {
    var script = document.querySelector('[data-sr-variant-data]');
    if (script) {
      try {
        var data = JSON.parse(script.textContent);
        _variantData = data.variants || {};
        _currencyCodeEnabled = data.currencyCodeEnabled || false;
      } catch(e) {
        console.error('[SR-View] Failed to parse variant data:', e);
      }
    }
  }
  
  // 格式化金额
  function fmtMoney(cents) {
    var s = '$' + (cents / 100).toFixed(2);
    if (_currencyCodeEnabled) s += ' USD';
    return s;
  }

  // ==================== 注册回调 ====================
  
  // 会员状态变化 → 更新产品价格显示
  SRController.on('member-changed', function(payload) {
    var stateCode = payload.stateCode;
    var data = payload.data || {};
    
    // 根据 stateCode 路由到对应渲染模块
    switch(stateCode) {
      case SRController.STATES.VISITOR:
        renderVisitorMode(data);
        break;
      
      case SRController.STATES.MEMBER:
        renderMemberMode(data);
        break;
      
      case SRController.STATES.EMAIL_INVALID:
        showError('Invalid email format');
        break;
      
      case SRController.STATES.EMAIL_CONFLICT:
        showError('This email is already in use');
        break;
      
      case SRController.STATES.PENDING_CONFIRM:
        showConfirmDialog(data.email);
        break;
      
      case SRController.STATES.EMAIL_CHANGED:
        showSuccess('Email updated successfully');
        break;
      
      case SRController.STATES.OTP_SENT:
        showOtpInput();
        break;
      
      case SRController.STATES.OTP_VERIFIED:
        renderMemberMode(data);
        showSuccess('Verification successful');
        break;
      
      case SRController.STATES.ERROR:
        showError(data.error || 'An error occurred');
        break;
      
      default:
        console.error('[SR-View] 未知 stateCode:', stateCode);
    }
  });
  
  // 购物车变化 → 更新购物车角标（示例）
  SRController.on('cart-changed', function(payload) {
    // TODO: 实现购物车角标更新逻辑
    console.log('[SR-View] 购物车状态变化:', payload);
  });

  // ==================== 渲染模块 ====================

  /**
   * 访客模式渲染
   * stateCode = 1
   */
  function renderVisitorMode(data) {
    var row = document.querySelector('[data-sr-insider-row]');
    if (!row) return;
    
    // 显示原价
    var priceOriginal = document.querySelectorAll('[data-sr-price-original]');
    for (var i = 0; i < priceOriginal.length; i++) {
      priceOriginal[i].style.display = '';
    }
    
    // 隐藏会员价（Insider 行仍然显示，但按钮改为 JOIN）
    var priceMember = document.querySelectorAll('[data-sr-price-member]');
    for (var i = 0; i < priceMember.length; i++) {
      priceMember[i].style.display = 'none';
    }
    
    // 按钮显示 JOIN
    var joinBtn = row.querySelector('[data-sr-join-trigger]');
    if (joinBtn) {
      joinBtn.textContent = 'JOIN';
      joinBtn.style.display = '';
      joinBtn.classList.remove('sr-member-mode');
    }
  }

  /**
   * 会员模式渲染
   * stateCode = 2
   */
  function renderMemberMode(data) {
    var row = document.querySelector('[data-sr-insider-row]');
    if (!row) return;
    
    // 隐藏原价
    var priceOriginal = document.querySelectorAll('[data-sr-price-original]');
    for (var i = 0; i < priceOriginal.length; i++) {
      priceOriginal[i].style.display = 'none';
    }
    
    // 显示会员价
    var priceMember = document.querySelectorAll('[data-sr-price-member]');
    for (var i = 0; i < priceMember.length; i++) {
      priceMember[i].style.display = '';
    }
    
    // 按钮显示 MEMBER PRICE
    var joinBtn = row.querySelector('[data-sr-join-trigger]');
    if (joinBtn) {
      joinBtn.textContent = 'MEMBER PRICE';
      joinBtn.classList.add('sr-member-mode');
    }
  }

  // ==================== 辅助函数 ====================

  function showError(message) {
    var errorDiv = document.querySelector('[data-sr-error]');
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.style.display = '';
    }
  }

  function showSuccess(message) {
    var successDiv = document.querySelector('[data-sr-success]');
    if (successDiv) {
      successDiv.textContent = message;
      successDiv.style.display = '';
    }
  }

  function showConfirmDialog(email) {
    // TODO: 实现确认弹窗
    console.log('[SR-View] 确认弹窗:', email);
  }

  function showOtpInput() {
    // TODO: 实现 OTP 输入框
    console.log('[SR-View] OTP 输入框');
  }

  // ==================== Variant 切换处理 ====================
  
  function updateMemberPrice(variantId) {
    if (!variantId || !_variantData || !_variantData[variantId]) return;
    
    var v = _variantData[variantId];
    var row = document.querySelector('[data-sr-insider-row]');
    if (!row) return;
    
    var valEl = row.querySelector('[data-sr-member-price-value]');
    var saveEl = row.querySelector('[data-sr-member-save]');
    
    if (valEl) valEl.textContent = fmtMoney(v.memberPrice);
    if (saveEl) saveEl.textContent = 'Save ' + fmtMoney(v.save);
  }
  
  // 监听 variant 切换事件
  function initVariantListeners() {
    // T4S 主题事件
    document.addEventListener('variant:changed', function(e) {
      if (e.detail && e.detail.variant) updateMemberPrice(e.detail.variant.id);
    });
    document.addEventListener('variantChange', function(e) {
      if (e.detail && e.detail.variant) updateMemberPrice(e.detail.variant.id);
    });
    
    // 监听 hidden input 变化
    var sel = document.querySelector('form[action*="/cart/add"] select[name="id"],form[action*="/cart/add"] input[name="id"][type="hidden"]');
    if (sel) {
      var obs = new MutationObserver(function() { updateMemberPrice(sel.value); });
      obs.observe(sel, { attributes: true, attributeFilter: ['value'] });
      sel.addEventListener('change', function() { updateMemberPrice(sel.value); });
    }
  }

  // ==================== JOIN 按钮处理 ====================
  
  function initJoinButton() {
    var row = document.querySelector('[data-sr-insider-row]');
    if (!row) return;
    
    var joinBtn = row.querySelector('[data-sr-join-trigger]');
    if (!joinBtn) return;
    
    joinBtn.addEventListener('click', function(e) {
      e.preventDefault();
      // 打开会员弹窗
      SRCommand.dispatch(SRCommand.CMD.POPUP_OPEN);
    });
  }

  // ==================== 初始化 ====================
  
  function init() {
    // 加载 variant 数据
    loadVariantData();
    
    // 初始化 variant 监听器
    initVariantListeners();
    
    // 初始化 JOIN 按钮
    initJoinButton();
    
    // 根据当前状态立即渲染一次
    if (SRController.isMember()) {
      renderMemberMode(SRController.get());
    } else {
      renderVisitorMode(SRController.get());
    }
  }
  
  // DOM 加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  console.log('[SR-View] v2.1 ready');
})();

